export default {
    smsSent: 'Vaš SMS je uspešno poslat. Ako SMS nije stigao, možete ponovo poslati SMS za {n} sekundi',

    buttons: {
        save: 'Sačuvaj',
        resend: 'Pošalji SMS ponovo',
    },
    fields: {
        token: {
            label: 'Unesite verifikacioni kod iz SMS poruke',
            placeholder: '******',
        },
    },
    errors: {
        user_invalid_change_mobile_token: 'Verifikacioni kod nije ispravan!',
    },
}
